import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import { LOCAL_MCP_LABEL_PREFIX } from '../McpCatalogConstant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function McpCatalogListItem({ item, onDelete, onItemClick }) {
    useTranslationSubscription();
    const displayName = `${LOCAL_MCP_LABEL_PREFIX}${item.mcpName}`;
    const deleteLabel = `${trI18n('BUTTON-DELETE-LOCAL-MCP')}: ${displayName}`;

    const handleItemClick = () => {
        onItemClick(item);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onItemClick(item);
        }
    };

    const handleDeleteClick = (e) => {
        e.stopPropagation();
        onDelete(item);
    };

    return (
        <li className="mcp-catalog-item" onClick={handleItemClick} onKeyDown={handleKeyDown} role="button" tabIndex={0}>
           <OverFlowTooltipWithTabsMui className="mcp-catalog-item-name" value={displayName} />
            <IconButton
                className="mcp-catalog-delete-button"
                aria-label={deleteLabel}
                onClick={handleDeleteClick}
            >
                <img className="mcp-catalog-delete-icon" src="/assets/image/delete-icon.svg" alt="" />
            </IconButton>
        </li>
    );
}

McpCatalogListItem.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.string.isRequired,
        mcpName: PropTypes.string.isRequired
    }).isRequired,
    onDelete: PropTypes.func.isRequired,
    onItemClick: PropTypes.func.isRequired
};
